import { Box, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    overlay: {
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        "&::before": {
            content: "''",
            position: "absolute",
            inset: 0,
            background: theme.palette.tailwind.slate[900],
            opacity: 0.55,
        },
    },
    card: {
        position: "relative",
        zIndex: 1,
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
        color: theme.palette.text.primary,
        borderRadius: "0.5rem",
        padding: "4rem 2.5rem",
        maxWidth: "44rem",
        minHeight: "20rem",
        textAlign: "center",
        boxShadow: theme.shadows[3],
    },
    title: {
        fontWeight: 600,
    },
    orderIdLink: {
        color: theme.palette.tailwind.blue[600],
        textDecoration: "underline",
    },
}))

type CreditNoteOverlayProps = Readonly<{
    orderId?: number
}>

export function CreditNoteOverlay({ orderId }: CreditNoteOverlayProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.overlay}>
            <Stack gap="1.5rem" className={classes.card}>
                <LocalizedStrict id="create-order-credit-note-overlay-title">
                    <Typography variant="h4" className={classes.title}>
                        Credit note
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict
                    id="create-order-credit-note-overlay-message-with-order-id"
                    vars={{ orderId: orderId ? String(orderId) : "-" }}
                    elems={{
                        orderIdLink: <span className={classes.orderIdLink} />,
                        lineBreak: <br />,
                    }}
                >
                    <Typography>
                        You are creating a credit note for order ID #{orderId}. Please add the products you wish to
                        credit in the cart on the right.
                    </Typography>
                </LocalizedStrict>
            </Stack>
        </Box>
    )
}
